import { t } from "@/i18n";

const TURN = {
  left: "Svolta a sinistra", right: "Svolta a destra", "slight left": "Svolta leggermente a sinistra",
  "slight right": "Svolta leggermente a destra", "sharp left": "Svolta decisamente a sinistra",
  "sharp right": "Svolta decisamente a destra", straight: "Prosegui dritto", uturn: "Fai inversione a U",
};

export function instructionText(s) {
  if (!s) return t("Segui il percorso");
  if (s.provider === "here" || !s.type) return s.instruction;
  const m = s.modifier || "straight";
  let base;
  if (s.type === "depart") base = t("Parti");
  else if (s.type === "arrive") return t("Sei arrivato a destinazione");
  else if (["roundabout", "rotary", "roundabout turn"].includes(s.type)) base = s.exit ? t("Alla rotatoria prendi la {n}ª uscita", { n: s.exit }) : t("Entra nella rotatoria");
  else if (s.type === "on ramp") base = t("Prendi la rampa");
  else if (s.type === "off ramp") base = t("Prendi l'uscita");
  else if (s.type === "fork") base = t(m.includes("left") ? "Al bivio tieni la sinistra" : m.includes("right") ? "Al bivio tieni la destra" : "Prosegui dritto");
  else if (s.type === "merge") base = t("Immettiti");
  else base = t(TURN[m] || "Prosegui dritto");
  return s.road ? `${base} ${t("su {road}", { road: s.road })}` : base;
}
